import axios from "axios";
import { endPoint } from "../EndPoints/endPoint";

const defaultHeaders = {
    // 'Accept': 'application/json',
    'Content-Type': 'application/json',
    "apiKey": "V+kBloEwqqVho1PINmQI0VJQwSBX2l/e",
};
let headersForm = {
    "Content-Type": "multipart/form-data",
}

class LeaseApiService {
    constructor() {
        this.axiosInstance = axios.create({
            baseURL: "https://leasing.pro360dev.freemyip.com",
            headers: defaultHeaders,
        });

        this.axiosInstance.interceptors.request.use(this.requestInterceptor);
        this.axiosInstance.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);
    }

    requestInterceptor = (config) => {
        const token = this.getToken();
        const company = this.getCompany();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['DB'] = `${company}`;
            // config.headers['DB'] = `PMK4000`;
        }

        return config;
    };

    responseInterceptor = (response) => {

        return response;
    };

    errorInterceptor = async (error) => {
        if (error.response && error.response.status === 401) {
            const token = this.getToken();
            if (token) {
                await this.handleRefreshToken();
                const newToken = this.getToken();
                if (newToken) {
                    error.config.headers['Authorization'] = `Bearer ${newToken}`;
                    return axios.request(error.config);
                } else {
                    console.error('Token refresh failed');
                    return Promise.reject(error);
                }
            } else if (this.isLoginOrSignupRequest(error.config)) {
                return axios.request(error.config);
            } else {
                console.error('User not authenticated');
                return Promise.reject(new Error('Unauthorized'));
            }
        } else {
            return Promise.reject(error);
        }
    };

    isLoginOrSignupRequest(config) {
        const url = config.url;
        return url.includes('USER_LOGIN') || url.includes('USER_SIGNUP');
    }

    async handleRefreshToken() {

        try {
            const response = await this.axiosInstance.post(endPoint['REFRESH_TOKEN'], {
                token: this.getToken(),
                refreshToken: this.getRefreshToken(),
            });

            if (response.status === 200) {
                this.setToken(response.data.result.token);
            }
        } catch (error) {
            console.error('Token refresh failed', error);
        }
    }

    getToken() {
        return localStorage.getItem('Token');
    }
    getCompany() {
        return localStorage.getItem('DataBase');
    }
    setToken(token) {
        localStorage.setItem('Token', token);
    }

    getRefreshToken() {
        return localStorage.getItem('RefreshToken');
    }

    setRefreshToken(refreshToken) {
        localStorage.setItem('RefreshToken', refreshToken);
    }

    async get(path) {
        return this.axiosInstance.get(endPoint[path]);
    }
    async getApiParamater(path, data) {
        return this.axiosInstance.get(endPoint[path] + data);
    }
    async post(path, data) {
        return this.axiosInstance.post(endPoint[path], data);
    }
    async postMultiPart(path, body) {
        let res = false;
        await this.axiosInstance
            .post(endPoint[path], body, headersForm)
            .then((response) => {
                res = response;
            })
            .catch((err) => {
                res = err?.response?.data?.message;
            });
        return res;
    }
    async putMultiPart(path, body) {
        let res = false;
        await axios
            .put(endPoint[path], body, headersForm)
            .then((response) => {
                res = response;
            })
            .catch((err) => {
                res = err?.response?.data?.message;
            });
        return res;
    }
    async GetMultiPart(path, body) {
        let res = false;
        await axios.get(endPoint[path], body, headersForm)
            .then((response) => {
                res = response;
            })
            .catch((err) => {
                res = err?.response?.data?.message
            });
        return res;
    }
    async put(path, data) {
        return this.axiosInstance.put(endPoint[path], data);
    }
    // async delete(path, data) {
    //     return this.axiosInstance.delete(endPoint[path], data);
    // }
    async delete(path, data) {
        return this.axiosInstance.delete(endPoint[path], {
            headers: { "Content-Type": "application/json" },
            data
        });
    }
    async deleteParameter(path, data) {
        return this.axiosInstance.delete(endPoint[path] + data);
    }
    async getLeaseReceiptByNo(receiptNo) {
        return this.axiosInstance.get(`${endPoint['GET_RECEIPT_BY_NO']}${receiptNo}`);
    }
    async updateLeaseReceipt(receiptNo, body) {
        return this.axiosInstance.put(`${endPoint['UPDATE_LEASE_RECEIPT']}${receiptNo}`, body);
    }
    async getGeneralInvoiceByVoucherNo(voucherNo, financialYear) {
        const query = financialYear ? `?financialYear=${encodeURIComponent(financialYear)}` : '';
        return this.axiosInstance.get(`${endPoint['GEN_INV_BY_VOUCHER']}${voucherNo}${query}`);
    }
    async updateGeneralInvoice(voucherNo, body) {
        return this.axiosInstance.put(`${endPoint['GEN_INV_UPDATE']}${voucherNo}`, body);
    }

    // ---- Lease Balance Refund (listing / view / edit) ----
    // These resolve to { ok, status, message, result, pagination } and never throw.
    // 400 -> server message (user readable); 404 / 5xx / network -> fixed messages.

    /**
     * @typedef {{ voucherNo?: string, leaseNo?: string, tenantNo?: string, propertyNo?: string, paymentMethod?: string,
     *   status?: 'Pending'|'Approved', fromDate?: string, toDate?: string, financialYear?: string, pageNo?: number, pageSize?: number }} BalanceRefundFilters
     * @typedef {{ voucherNo: string, financialYear: string, postingDate: string, voucherType: string, leaseNo: string, propertyNo: string,
     *   propertyName: string, unitNo: string, tenantNo: string, tenantName: string, paidTo: string, paymentMethod: string, chequeNo: string,
     *   chequeDate: string, bankAccountCode: string, bankAccountName: string, amount: number, refNo: string, remarks: string,
     *   createdBy: string, createdOn: string, isApproved: boolean, canEdit: boolean, totalRecords: number }} BalanceRefundRow
     * @typedef {{ voucherNo: string, financialYear: string, postingDate: string, voucherType: string, leaseNo: string, propertyNo: string,
     *   propertyName: string, unitNo: string, tenantNo: string, tenantName: string, paidTo: string, paymentMethod: string, chequeNo: string,
     *   chequeDate: string, drawnBank: string, bankAccountCode: string, bankAccountName: string, amount: number, refNo: string,
     *   narration: string, createdBy: string, createdOn: string, isApproved: boolean, canEdit: boolean }} BalanceRefundHeader
     * @typedef {{ accountCode: string, accountName: string, debit: number, credit: number }} BalanceRefundPostingLine
     * @typedef {{ header: BalanceRefundHeader, postingLines: BalanceRefundPostingLine[],
     *   sdAdjustment: { voucherNo: string, postingDate: string, amount: number } | null }} BalanceRefundDetail
     * @typedef {{ financialYear: string, postingDate: string, bankAccountCode: string, paymentMethod: string, chequeNo: string|null,
     *   chequeDate: string|null, drawnBank: string|null, refNo: string|null, paidTo: string|null, narration: string|null }} BalanceRefundUpdateRequest
     */
    async balanceRefundCall(request, notFoundMessage) {
        const generic = 'Something went wrong. Please try again.';
        try {
            const res = await request();
            const body = res?.data;
            const status = res?.status === 204 ? 204 : (body?.statusCode ?? res?.status);
            return {
                ok: status >= 200 && status < 300,
                status,
                message: body?.message || '',
                result: body?.result ?? body?.data ?? null,
                pagination: body?.paginationData ?? null,
            };
        } catch (error) {
            const status = error?.response?.status || 0;
            let message = generic;
            if (status === 400) message = error?.response?.data?.message || generic;
            else if (status === 404) message = notFoundMessage;
            return { ok: false, status, message, result: null, pagination: null };
        }
    }
    /** @param {BalanceRefundFilters} filters @returns {Promise<{ok:boolean,status:number,message:string,result:BalanceRefundRow[]|null,pagination:any}>} */
    async getBalanceRefundList(filters = {}) {
        const q = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && `${value}`.trim() !== '') q.append(key, `${value}`.trim());
        });
        const qs = q.toString();
        return this.balanceRefundCall(
            () => this.axiosInstance.get(endPoint['BLNC_REF_LIST'] + (qs ? `?${qs}` : '')),
            'No refund vouchers found.',
        );
    }
    /** @returns {Promise<{ok:boolean,status:number,message:string,result:BalanceRefundDetail|null}>} */
    async getBalanceRefundByVoucher(voucherNo, financialYear) {
        return this.balanceRefundCall(
            () => this.axiosInstance.get(`${endPoint['BLNC_REF_BY_VOUCHER']}${encodeURIComponent(voucherNo)}?financialYear=${encodeURIComponent(financialYear || '')}`),
            "Refund voucher not found or you don't have access to it.",
        );
    }
    /** @param {BalanceRefundUpdateRequest} body @returns {Promise<{ok:boolean,status:number,message:string,result:{voucherNo:string,financialYear:string}|null}>} */
    async updateBalanceRefund(voucherNo, body) {
        return this.balanceRefundCall(
            () => this.axiosInstance.put(`${endPoint['BLNC_REF_UPDATE']}${encodeURIComponent(voucherNo)}`, body),
            "Refund voucher not found or you don't have access to it.",
        );
    }
}

export default LeaseApiService;

